import signInFormFields from "./sign-in-form";
import signUpFormFields from "./sign-up-form";
import techSupportFormFields from "./tech-support-form";
import countersNewValueFormFields from "./counters-new-value";
import passwordRecoveryFormFields from "./password-recovery-form";
import contractAddingFormFields from "./contract-adding-form";
import emailReplacementFormFields from "./email-replacement-form";
import passwordReplacementFormFields from "./password-replacement-form";
import documentGetterFormFields from "./document-getter-form";
import datePickerFormFields from "./date-picker-form";
// import hourlyGetterFormFields from "./hourly-getter-form";
import datePickerAsSingleField from "./date-picker-as-single-field";
import accountingPointPlanFormFields from "./accounting-point-plan-form";
import confirmActionFormFields from "./confirm-action-form";
import confirmCountersNewValueFields from "./confirm-counters-new-values";
import appealChatFormFields from "./appeal-chat-form";
import paymentFormFields from "./payment-form";
import paymentNoAuthFormFields from "../form-fields/payment-no-auth-form";

import { prepareFieldsForComponent } from "@/assets/scripts/form-utils";
import {Field} from "@/models/form";

const forms = [
  signInFormFields,
  signUpFormFields,
  techSupportFormFields,
  countersNewValueFormFields,
  passwordRecoveryFormFields,
  contractAddingFormFields,
  emailReplacementFormFields,
  passwordReplacementFormFields,
  documentGetterFormFields,
  datePickerFormFields,
  datePickerAsSingleField,
  accountingPointPlanFormFields,
  confirmActionFormFields,
  // hourlyGetterFormFields,
  confirmCountersNewValueFields,
  appealChatFormFields,
  paymentFormFields,
  paymentNoAuthFormFields,
] as const;

// Поля ввода, подготовленные к использованию в рамках соответствующих компонентов.
const [
  signInForm,
  signUpForm,
  techSupportForm,
  countersNewValueForm,
  passwordRecoveryForm,
  contractAddingForm,
  emailReplacementForm,
  passwordReplacementForm,
  documentGetterForm,
  datePickerForm,
  datePickerFormAsSingleField,
  accountingPointPlanForm,
  confirmActionForm,
  // hourlyGetterForm,
  confirmCountersNewValueForm,
  appealChatForm,
  paymentForm,
  paymentNoAuthForm,
] = forms.map(formFields => prepareFieldsForComponent(formFields as Field[]));

export {
  signInForm,
  signUpForm,
  techSupportForm,
  countersNewValueForm,
  passwordRecoveryForm,
  contractAddingForm,
  emailReplacementForm,
  passwordReplacementForm,
  documentGetterForm,
  datePickerForm,
  datePickerFormAsSingleField,
  accountingPointPlanForm,
  confirmActionForm,
  // hourlyGetterForm,
  confirmCountersNewValueForm,
  appealChatForm,
  paymentForm,
  paymentNoAuthForm,
};
